'use strict';

angular.module('webAgro1App').filter('getTextItems', function() {
  return function (items, field) {
    field = field || 'descricao';

    if (items) {
      return items.map(function (item) {
        var key = Object.keys(item)[0];
        if (key && item[key][field]) {
          return item[key][field];
        }

        return item[field] ? item[field] : item[field];
      }).join(', ');
    }

    return '';
  };
});
